module.exports = __webpack_public_path__ + "img/newLicense.38bac0f5.png";